
import Card from 'vux/src/components/card/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Masker from 'vux/src/components/masker/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import FootNav from '../../components/FootNav.vue'

export default {
components: {Card, Divider, FootNav, Masker, XHeader},
data() {
return {
list: [],
banner: '',
pageLoaded: false
}
},
mounted: function () {
document.title = '天一商城'
this.$nextTick(function () {
this.$vux.loading.show('加载中')
const url = this.tianYiWebUrl + '/wechat/shop/ajaxIndex'
this.$http.get(url).then(res => {
if (res.data.code === 200) {
this.banner = res.data.data.banner;
this.list = res.data.data.list
}
this.$vux.loading.hide();
this.pageLoaded = true;
})
})
},
methods: {}
}



// WEBPACK FOOTER //
// ./src/components/shop/Index.vue